import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-time-worked-notes-modal',
  templateUrl: './time-worked-notes-modal.component.html',
  styleUrls: ['./time-worked-notes-modal.component.css']
})
export class TimeWorkedNotesModalComponent implements OnInit {
  @Input() notes: any;
  @Input() isSubmitted: any;
  selectedNote: any;

  constructor(private activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.selectedNote = this.notes[0];
  }

  updateClicked() {
    this.activeModal.close({ Action: 'update', Note: this.selectedNote });
  }

  cancelClicked() {
    this.activeModal.dismiss();
  }

}